import React from 'react'
import "./style.scss"
import Steps, { TitleUpStepDisplay } from './widgets/Steps'
import { CContainer } from '@coreui/react'
import StepContents from './widgets/stepContent'
import Header from './widgets/Header'
import Footer from './widgets/Footer'

const ExternalPurchaseWizard = () => {

    return (
        <div className='external-purchase-container'>
            <Header />
            <TitleUpStepDisplay />
            <CContainer>
                <div className='main-context' >
                    <Steps />
                    <StepContents />
                </div>
            </CContainer>
            <Footer />
        </div>
    )
}

export default ExternalPurchaseWizard